module.exports = __webpack_public_path__ + "static/media/cloud-download.ebd06da3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cloud-download.svg
// module id = 246
// module chunks = 0